import { Typography, Button, Input, Form, Layout, Card, Flex } from "antd";
import { useNavigate } from "react-router-dom";
import * as Validation from "../../../utils/helper/validation";
import * as APIS from "../../../utils/helper/enum";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { changeLoader } from "../../../redux/reducers/loader";
import globalRequest from "../../../utils/global/globalRequest";
import { useLocation } from "react-router-dom";
import toast from "react-hot-toast";
const { Title } = Typography;

const ResetPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [apiError, setApiError] = useState({});
  const [form] = Form.useForm();
  const location = useLocation();

  // Create a URLSearchParams object from the query string
  const queryParams = new URLSearchParams(location.search);
  const tokenData = queryParams.get("token");

  const handleInputChange = (name) => {
    form.setFields([
      {
        name,
        errors: [],
      },
    ]);
    setApiError((prevError) => ({
      ...prevError,
      [name]: undefined, // Clear the error for the field
    }));
  };

  const handleSubmit = async (values) => {
    dispatch(changeLoader(true));
    values.password_token = tokenData;
    try {
      let response = await globalRequest(
        APIS?.ONBOARDING_APIS?.RESET_PASSWORD,
        "put",
        values
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Password Rest successfully, please login.";
        toast.success(msg, {
          duration: 2000,
        });
        navigate("/");
      } else {
        // setApiError({email:apiResponse.message});
        toast.error(apiResponse.message, {
          duration: 2000,
        });
      }
    } catch (e) {
      console.log(e);
    }
    dispatch(changeLoader(false));
  };

  return (
    <>
      <Layout style={{ minHeight: "100vh" }}>
        <Flex
          gap="middle"
          align="center"
          justify="center"
          vertical
          style={{
            minHeight: "100vh",
            padding: "18px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Card
            className="relative"
            style={{
              width: "100%",
              maxWidth: 500,
              boxSizing: "border-box",
              ...(window.innerWidth < 768 ? { width: "100%" } : {}),
            }}
          >
            <img
              width={170}
              src="logo.svg"
              alt=""
              className="mx-auto absolute top-[-70px] left-0 right-0"
            />
            <Title level={3} align={"center"}>
              Reset Password
            </Title>
            <Form
              name="login"
              layout="vertical"
              onFinish={handleSubmit}
              style={{
                width: "100%",
                marginTop: 24,
              }}
            >
              <Form.Item
                label="New Password"
                name="password"
                rules={[
                  {
                    required: true,
                    message: "Please input your password!",
                  },
                ]}
                help={apiError && apiError.password}
                validateStatus={apiError && apiError.password ? "error" : ""}
                validateTrigger={"onSubmit"}
              >
                <Input.Password
                  size="large"
                  onChange={(e) => {
                    let value = Validation.strFormat(e.target.value, "trim");
                    form.setFieldValue("password", value);
                    handleInputChange("password");
                  }}
                  placeholder="Please Enter Your Password"
                />
              </Form.Item>
              <Form.Item
                label="Confirm New Password"
                name="confirm_password"
                rules={[
                  {
                    required: true,
                    message: "Please confirm your password!",
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error(
                          "New Password and confirm password does not match."
                        )
                      );
                    },
                  }),
                ]}
                help={apiError && apiError.confirm_password}
                validateStatus={
                  apiError && apiError.confirm_password ? "error" : ""
                }
                validateTrigger={"onSubmit"}
              >
                <Input.Password
                  size="large"
                  onChange={(e) => {
                    let value = Validation.strFormat(e.target.value, "trim");
                    form.setFieldValue("confirm_password", value);
                    handleInputChange("confirm_password");
                  }}
                  placeholder="Please Enter Your Confirm Password"
                />
              </Form.Item>

              <Button
                className="w-full mt-4"
                size="large"
                type="primary"
                htmlType="submit"
                onClick={() => form.submit()}
              >
                Change Password
              </Button>
            </Form>
          </Card>
        </Flex>
      </Layout>
    </>
  );
};

export default ResetPassword;
